import React, { useRef } from "react";
import HeroSection from "../components/Homepage/HeroSection";
import OurExpertise from "../components/Homepage/OurExpertise";
import OurOfferings from "../components/Homepage/OurOfferings";
import UseCases from "../components/Homepage/UseCases";
import WhatWeBuilt from "../components/Homepage/WhatWeBuilt";
import Blogs from "../components/Homepage/Blogs";
import NewsLetter from "../components/Homepage/NewsLetter";

const Home = () => {
  const targetRef = useRef(null);

  const handleScroll = () => {
    targetRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-white">
      <div className="flex flex-col items-center justify-start mx-auto overflow-hidden">
        <HeroSection handleScroll={handleScroll} />
        <OurExpertise />
        <OurOfferings />
        <UseCases />
        <WhatWeBuilt targetRef={targetRef} />
        <Blogs />
        <NewsLetter />
      </div>
    </div>
  );
};

export default Home;
